// @ts-nocheck

import { createSelector } from 'reselect';

import { selectBoomGlobalSkinId } from '../../modules/boom/selectors/global/globalPrimary.selector';
import { selectBoomUserNotifications } from '../../modules/boom/selectors/user/userPrimary.selector';
import { type Selector } from '../../types/selectors';

const selectNbBoomNotifications: Selector<number> = createSelector(
  [selectBoomUserNotifications],
  (notifications) => notifications.length ?? 0,
);

type BoomButtonPropsType = {
  nbBoomNotifications: number;
};

const selectBoomButtonProps: Selector<BoomButtonPropsType> = createSelector(
  [selectNbBoomNotifications, selectBoomGlobalSkinId],
  (nbBoomNotifications, skinId) => ({
    nbBoomNotifications,
    skinId,
  }),
);

export default selectBoomButtonProps;
